<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 py-3 px-0">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            {{ title || 'Pagos Rechazados' }}
          </h3>
          <div class="row">
            <div class="form-group col-12 col-xl-10 mb-0 mb-md-4 px-0">
              <div class="row">
                <div class="col-12 col-lg-4 px-0">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="inputQuery"
                    style="height: 42px"
                    @input="applyQueryFilter"
                  />
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <label for="">Mes</label>
                  <Multiselect
                    v-model="selectedMonth"
                    :options="months"
                    label="name"
                    placeholder="Mes"
                    :show-labels="false"
                    id="typeStatus"
                    @input="applyDateFilter"
                  ></Multiselect>
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-3 pr-0 div-select">
                  <label for="">Año</label>
                  <input
                    class="form-control"
                    min="2000"
                    :max="new Date().getFullYear()"
                    @change="applyDateFilter"
                    type="number"
                    style="height: 42px"
                    id="year"
                    v-model.number="selectedYear"
                    placeholder="Año"
                  />
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <label for="">Tipo </label>
                  <Multiselect
                    v-model="selectedTypePayment"
                    :options="typePayments"
                    label="name"
                    placeholder="Tipo"
                    :show-labels="false"
                    id="typePayment"
                    @input="loadElements(currentPage, id_user_balance)"
                  ></Multiselect>
                </div>
                <div
                  class="col-2 mt-lg-1 pl-lg-3 pl-0 pr-0 ml-3 ml-lg-0"
                  :class="{
                    'd-flex justify-content-start mb-lg-2': !id_user_balance
                  }"
                >
                  <div
                    class="d-flex justify-content-start justify-content-lg-around pt-0 align-items-end"
                  >
                    <div
                      v-if="id_user_balance"
                      :class="{ 'mt-1 mt-lg-0': id_user_balance }"
                    >
                      <label for="">Estado </label>
                      <Multiselect
                        v-model="queryStatus"
                        style="width: 95%"
                        :options="status"
                        label="name"
                        placeholder="Estado"
                        :show-labels="false"
                        id="typeStatus"
                        @input="loadElements(currentPage, id_user_balance)"
                      ></Multiselect>
                    </div>
                    <button
                      class="btn px-2 d-flex align-items-center border-primary"
                      style="height: 42px"
                      @click="resetQuery()"
                    >
                      <i class="bi bi-eraser-fill text-primary"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-2 p-0 mb-3 pt-md-0 pl-xl-4 pl-0">
              <div class="pt-0 pl-md-1 pl-0" style="gap: 5px">
                <button
                  v-if="false"
                  type="button"
                  class="col-12 text-white mb-0 mt-md-0 mt-2 bg-primary border-0 mr-0 btn"
                  @click="goNewPayment"
                >
                  Crear Pago
                </button>
                <button
                  v-if="!id_user_balance"
                  type="button"
                  class="col-12 text-white mt-2 bg-primary border-0 ml-0 btn"
                  @click="goNewCollection"
                >
                  Crear Cobro
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card overflow-auto">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="text-center" scope="col">
                    <div class="font-weight-bold text-center">Orden</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">ID</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Fecha de pago
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Título</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Tipo</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Agremiado</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Banco</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Monto de cobro
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Monto pagado</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Estatus</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Referencia</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr v-for="item in payments" :key="item.reference">
                  <td class="text-center">
                    <span
                      class="rounded-lg w-100 py-1 d-flex justify-content-center text-white"
                      style="background-color: #1863e573"
                      >{{ item.order }}</span
                    >
                  </td>
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">
                    {{
                      item.payment_date === 'Invalid DateTime' ||
                      item.payment_date === null
                        ? ''
                        : item.payment_date.split('-').reverse().join('/')
                    }}
                  </td>
                  <td class="text-center">{{ item.title }}</td>
                  <td class="text-center">
                    {{ item.type_payment ? item.type_payment.name : '' }}
                  </td>
                  <td class="text-center">{{ item.company.company_name }}</td>
                  <td class="text-center">
                    {{
                      item.payment_bank_name !== 'null'
                        ? item.payment_bank_name
                        : ''
                    }}
                  </td>
                  <td class="text-center">
                    <span
                      v-if="
                        item.type_currency &&
                        item.type_currency.name === 'Dolar'
                      "
                      >$</span
                    >
                    <span
                      v-else-if="
                        item.type_currency && item.type_currency.name === 'Euro'
                      "
                      >€</span
                    >
                    <span
                      v-else-if="
                        item.type_currency &&
                        item.type_currency.name === 'Bolivares'
                      "
                      >Bs.</span
                    >
                    <span v-else></span>
                    {{
                      (
                        parseFloat(item.expected_amount || '0.00') +
                        parseFloat(item.delivery_amount || '0.00') +
                        parseFloat(item.iva_amount || '0.00') +
                        parseFloat(item.delivery_amount_taxed || '0.00')
                      ).toFixed(2)
                    }}
                  </td>
                  <td class="text-center">{{ item.amount }} Bs.</td>
                  <td class="text-center">
                    <span
                      class="badge text-white text-b w-100"
                      style="font-size: 0.8rem"
                      :class="{
                        'bg-warning': item.type_payment_status.id === 2,
                        'bg-secondary': item.type_payment_status.id === 1,
                        'bg-success': item.type_payment_status.id === 3,
                        'bg-danger': item.type_payment_status.id === 4
                      }"
                    >
                      {{ item.type_payment_status.name }}</span
                    >
                  </td>
                  <td class="text-center">
                    {{
                      item.reference_number !== 'null'
                        ? item.reference_number
                        : ''
                    }}
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip text="Ver imagen">
                        <button
                          class="btn bg-primary d-flex justify-content-center align-items-center border-0 mr-1 border-0 p-2"
                          @click="openImageModal(item.url_image)"
                        >
                          <i
                            class="text-white bi bi-eye-fill d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip text="Editar">
                        <button
                          class="btn bg-warning d-flex justify-content-center align-items-center border-0 ml-1 p-2"
                          @click="goEdit(item.id)"
                        >
                          <i
                            class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      v-if="showImageModal"
      class="modal-overlay"
      @click.self="closeImageModal"
    >
      <div class="modal-content" style="max-height: auto; width: auto">
        <img
          :src="selectedImageUrl"
          alt="Imagen del Pago"
          class=""
          style="max-height: 500px; width: auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  props: ['id_user_balance', 'title'],
  data() {
    return {
      routeSegment: '',
      inputQuery: '',
      payments: [],
      showImageModal: false,
      selectedImageUrl: null,
      selectedMonth: '',
      selectedYear: '',
      months: [
        { value: '', name: 'Todos' },
        { value: '01', name: 'Enero' },
        { value: '02', name: 'Febrero' },
        { value: '03', name: 'Marzo' },
        { value: '04', name: 'Abril' },
        { value: '05', name: 'Mayo' },
        { value: '06', name: 'Junio' },
        { value: '07', name: 'Julio' },
        { value: '08', name: 'Agosto' },
        { value: '09', name: 'Septiembre' },
        { value: '10', name: 'Octubre' },
        { value: '11', name: 'Noviembre' },
        { value: '12', name: 'Diciembre' }
      ],
      status: [],
      typePayments: [],
      selectedTypePayment: '',
      queryStatus: '',
      years: [{ value: '', name: 'Todos' }],
      buttonNewCollectionUrl: 'NewCollection',
      buttonNewPaymentUrl: 'NewMonthlyPaymentRecived',
      buttonEditUrl: 'EditMonthlyPaymentRecived',
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20
    }
  },
  components: {
    Multiselect
  },
  methods: {
    ...mapActions(['getData']),

    applyDateFilter() {
      this.inputQuery = ''
      this.searchQuery = `${this.selectedYear}-`
      if (this.selectedMonth.value) {
        this.searchQuery += `${this.selectedMonth.value}-`
      }
      this.loadElements(1, this.id_user_balance)
    },
    applyQueryFilter() {
      this.selectedMonth = ''
      this.selectedYear = ''
      this.searchQuery = this.inputQuery
      this.loadElements(1, this.id_user_balance)
    },
    resetQuery() {
      this.inputQuery = ''
      this.selectedMonth = ''
      this.selectedYear = ''
      this.selectedTypePayment = ''
      this.queryStatus = ''
      this.searchQuery = ''
      this.loadElements(1, this.id_user_balance)
    },
    openImageModal(imageUrl) {
      this.selectedImageUrl = imageUrl
      this.showImageModal = true
    },
    closeImageModal() {
      this.showImageModal = false
      this.selectedImageUrl = null
    },
    loadTypePayments() {
      const form = {
        url: 'type-payment/all',
        params: {
          query: '',
          page: 1,
          limit: 100,
          order_value: 'asc',
          order_key: 'name'
        }
      }
      return this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typePayments = [
              { value: '', name: 'Todos' },
              ...response.data.data.map((item) => ({
                value: item.id,
                name: item.name
              }))
            ]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadStatus(id_user_balance = null) {
      const form = {
        url: 'type-payment-status/all',
        params: {
          query: '',
          page: 1,
          limit: 100,
          order_value: 'asc',
          order_key: 'name'
        }
      }
      return this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.status = [
              { value: '', name: 'Todos' },
              ...response.data.data.map((item) => ({
                value: `[${item.id}]`,
                name: item.name
              }))
            ]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadElements(page = 1, id_user_balance = null) {
      const form = {
        url: 'payment/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit,
          order_value: 'desc',
          order_key: 'id',
          id_type_payment: this.selectedTypePayment.value,
          id_type_payment_status: '[4]', // Filtra por estado 4 (Rechazados)
          id_user: id_user_balance
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            const startOrder = (page - 1) * this.limit + 1
            this.payments = response.data.data.map((payment, index) => ({
              ...payment,
              order: startOrder + index
            }))

            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },

    goNewCollection() {
      this.$router.push({ name: this.buttonNewCollectionUrl })
    },
    goNewPayment() {
      this.$router.push({ name: this.buttonNewPaymentUrl })
    },
    goEdit(id) {
      this.$router.push({ name: this.buttonEditUrl, params: { id: id } })
    }
  },
  async mounted() {
    const pathParts = this.$route.path.split('/')
    const adminIndex = pathParts.indexOf('admin')
    console.log(adminIndex !== -1 ? pathParts[adminIndex + 1] : '')
    this.routeSegment = adminIndex !== -1 ? pathParts[adminIndex + 1] : ''
    await this.loadStatus(this.id_user_balance)
    await this.loadTypePayments()
    this.loadElements(1, this.id_user_balance)
  }
}
</script>

<style>
tr:last-child td {
  border-bottom: none;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}
</style>
